import type { ICurrencyValues } from '../../interfaces/CurrencyUtil'
import CurrencyHelper from '../Currency'

const transform = (currentValue: string | number) => {
  if (typeof currentValue === 'number') {
    return currentValue
  }
  return new CurrencyHelper(currentValue).value.float
}

export class CurrencyCalculator {
  private initialValue = 0

  private currentValue = 0

  constructor(initialValue: number | string) {
    this.initialValue = transform(initialValue)
    this.currentValue = transform(initialValue)
  }

  add(sumValue: number | string) {
    this.currentValue += transform(sumValue)
    return this
  }

  sub(sumValue: number | string) {
    this.currentValue -= transform(sumValue)
    return this
  }

  get values() {
    const localValue = this.currentValue < 0 ? 0 : this.currentValue
    const isOverpaid = this.currentValue < 0
    const overpaidAmount = isOverpaid
      ? new CurrencyHelper(String(Math.abs(this.currentValue))).value
      : ({
          cents: 0,
          float: 0,
          currency: '€0,00',
          text: '0,00',
        } as ICurrencyValues)

    return {
      ...new CurrencyHelper(String(localValue)).value,
      isOverpaid,
      overpaidAmount,
    }
  }
}

export default CurrencyCalculator
